import React from "react";
import { Link } from "react-router-dom";

export default function NavItem(props){

    const  {to, iconClass, label, onClick } = props;

    return (
        <Link to={to} className="navLink" onClick={onClick}>
        <li className="link dashNavLink"> 
            <div className="linkLogin dashLogout dashNavs">
            <span className={`userIcon dashIcon ${iconClass}`}></span>
            <span className="login dashLink">{label}</span>
            </div>
        </li>
        </Link>
    );
};


